module.exports = __webpack_public_path__ + "images/category_lp/brand/store_images/5_9368136cc3be650d74a41df1181b9261.png";